import React from 'react';
import moment from 'moment';
import LayoffModal from './LayoffModal';
import { useLayoffHistory } from './useLayoff';
import styles from './layoff.module.scss';

const HistoryModal = ({ layoff, onClose }) => {
  const { data: events = [], isLoading } = useLayoffHistory(layoff?.hash);

  return (
    <LayoffModal
      isOpen={!!layoff}
      title={`History: ${layoff?.employee?.name ?? ''}`}
      onClose={onClose}
    >
      {isLoading ? (
        <p>Loading history...</p>
      ) : (
        <ol className={styles.history}>
          {events.map((event, index) => (
            <li key={index}>
              <div className={styles.history_dot} aria-hidden='true' />
              <div className={styles.history_text}>
                <strong>{event.label}</strong>
                <span>
                  {event.actor}
                  {event.detail ? ` · ${event.detail}` : ''}
                </span>
              </div>
              <time dateTime={event.created_at}>
                {moment(event.created_at).format('MMM D, YYYY h:mm A')}
              </time>
            </li>
          ))}
        </ol>
      )}
    </LayoffModal>
  );
};

export default HistoryModal;
